import { FileUploader } from "react-drag-drop-files";
import { FileUploadChild } from "./Common";

export default function BulkUploadData(props) {
    const { fileType, setFileData, FileData, photo, photoExt, photoName, pageName = 'Bulk Upload', PageType, downloadFormat, BulkSubmit, handleBulk, handleClear, Status = [], ErrorData, fileName = '' } = props;



    return (
        <div style={{ display: "block", transition: 'all .5s ease' }}>
            {/*<Box*/}
            {/*    heading={true}*/}
            {/*    heading_title={'Bulk Upload Details'}*/}
            {/*>*/}
            {/*    <div className="row mx-2 ">*/}

            {/*        <div className='col-md-6 d-flex flex-column gap-1'>*/}
            {/*            <b className='form-label'>{("Note")} : </b>*/}
            {/*            <strong className='form-label'>{`1.${(" Please Upload Only Excel File of Format .xlsx.")}`}</strong>*/}
            {/*            */}{/*<strong className='form-label'>2. Below Given Fields and Excel Header Should be Same.</strong>*/}
            {/*            <strong className='form-label'>{`2.${(" Download Excel Format From Provided Link")}`}*/}
            {/*                <span onClick={downloadFormat} style={{ color: "#54aaf8", cursor: "pointer", marginLeft: "8px" }} className="download-link" >{("Download")}<i className="fa-solid fa-download"></i>*/}
            {/*                </span>*/}
            {/*            </strong>*/}

            {/*        </div>*/}
            {/*        <div className='col-md-6 px-2 py-2 rounded mb-2' style={{ boxShadow: '2px 2px 10px rgba(101, 155, 242,0.5)', borderTop: "2px solid #f18282", borderBottom: "2px solid #BF8CED" }}>*/}

            {/*            <label className="fontcolorweight form-label" htmlFor={'import'}>{(pageName)}*/}
            {/*                <span style={{ color: "red" }}> *</span>*/}
            {/*            </label>*/}
            {/*            <FileUploader classes='file-uploader bulk-upload'*/}
            {/*                handleChange={BulkSubmit}*/}
            {/*                types={["xlsx"]}*/}
            {/*                children={<FileUploadChild label='' message={fileName} types={["xlsx"]} />}*/}
            {/*            />*/}
            {/*            <div className="mt-2">*/}

            {/*                <button className="button-save me-2" onClick={handleBulk}>*/}
            {/*                    <i className="fa-solid fa-file-import me-1" /> {("Upload")}*/}
            {/*                </button>*/}

            {/*                <button className="button-reset mt-md-0 mt-2 me-2" onClick={handleClear}>*/}
            {/*                    <i className="fa-solid fa-arrows-rotate me-1" /> {("Reset")}*/}
            {/*                </button>*/}
            {/*            </div>*/}
            {/*            <div className='d-flex mb-1'>*/}
            {/*                {Status && Object.keys(Status).length > 0 && (*/}
            {/*                    <div className='text-success p-0 pt-2 m-0 fw-bold' style={{ lineHeight: '14px' }}>*/}
            {/*                        {("Success")} : {(Status.SuccessCount)} &nbsp; &nbsp;*/}
            {/*                        <span className='text-danger'>*/}
            {/*                            {("Error")} : {(Status.ErrorCount)}*/}
            {/*                            {Status.ErrorData && Status.ErrorData.length > 0 && (*/}
            {/*                                <>*/}
            {/*                                    &nbsp;<i className="fa fa-download color-success" style={{ cursor: 'pointer' }} onClick={ErrorData}></i>*/}
            {/*                                </>*/}
            {/*                            )}*/}
            {/*                        </span>*/}
            {/*                    </div>*/}
            {/*                )}*/}

            {/*            </div>*/}
            {/*        </div>*/}

            {/*    </div>*/}
            {/*</Box>*/}
        </div>
    )
}
export const ImportButton = ({ BulkSubmit, handleBulk, downloadFormat, children, Status = [], ErrorData }) => {
    return (
        <div className='border border-2 p-2 w-100' style={{ 'borderRadius': '8px' }}>
            <label className="form-label" htmlFor={'import'}>{'Bulk Upload'}
                <span style={{ color: "red" }}> *</span>
            </label>
            <FileUploader handleChange={BulkSubmit} name="file" types={["xlsx"]} />
            <div className='mt-2'>
                <button className="btn btn-rounded btn-primary me-3 mb-0" style={{ minWidth: '8px' }} onClick={handleBulk}>
                    <i className="fa fa-upload text-white color-success"></i> Upload
                </button>
                <span type="button" style={{ minWidth: '8px', textDecoration: 'underline', color: 'blue', fontSize: '13px' }} onClick={downloadFormat}>
                    Download Format <i className="fa fa-download color-success"></i>
                </span>
            </div>
            {/*<textarea className='form-control' readOnly>{HeaderFormat}</textarea>*/}
            <div className='d-flex mb-1'>
                {Status?.length !== 0 ?
                    <>
                        <div className='text-success p-0 pt-2 m-0 fw-bold' style={{ lineHeight: '14px' }}>Success : {Status?.SuccessCount} &nbsp; &nbsp;
                            <span className='text-danger'>Error : {Status?.ErrorCount}
                                {Status?.length !== 0 && Status?.ErrorData?.length !== 0 ?
                                    <>&nbsp;<i className="fa fa-download  color-success" style={{ cursor: 'pointer' }} onClick={ErrorData}></i></>
                                    : ""}
                            </span></div>
                    </>
                    : ""}
            </div>

            {children}
        </div>
    )
}